import { render } from "./CreateMomentView.vue?vue&type=template&id=1ffb3be3&scoped=true"
import script from "./CreateMomentView.vue?vue&type=script&lang=js"
export * from "./CreateMomentView.vue?vue&type=script&lang=js"

import "./CreateMomentView.vue?vue&type=style&index=0&id=1ffb3be3&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffb3be3"]])

export default __exports__